import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { ScoreType } from '~/types/aso'

import { COLORS } from './colors'

import './styles.scss'

export interface ScoreComponentProps {
  className?: string
  isMetadata?: boolean
  isPercentage?: boolean
  total?: number
  type: ScoreType
  value: number
}

const Score = ({
  className,
  isMetadata,
  isPercentage = true,
  total = 100,
  type,
  value: initialValue,
}: ScoreComponentProps): ReactElement => {
  const componentClasses = classNames('score-component', className, { metadata: isMetadata })
  const value = isPercentage ? parseInt((initialValue * 100).toFixed(2)) : initialValue
  const color = COLORS[type][total >= 10 ? Math.ceil(value / 10) * 10 : value]
  const forgroundBackgroundColor = `${color}33`

  return (
    <div className={componentClasses}>
      <div className="numeric-display" style={{ color }}>
        <span className="emphased-number">{value}</span>/{total}
      </div>
      <div className="graphic-display">
        <div className="graphic-background" style={{ backgroundColor: forgroundBackgroundColor }}>
          <div
            className="graphic-foreground"
            style={{
              backgroundColor: color,
              width: `${(value * 100) / total}%`,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default Score
